/** @format */

import { Locale } from "../../../features/i18n/init";
import { Resource, ResourceReference } from "../../../features/resources/types";
import { api } from "../api";
import { DeepPartial } from "@reduxjs/toolkit";
import { FullResource } from "../../../features/resources/ResourceFunctions";

export const resourcesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getResource: build.query<Resource, string>({
      query: (resourceId: string) =>
        `resource/${resourceId.toLocaleLowerCase()}`,
      providesTags: ["Resource"],
    }),
    getResourceReference: build.query<
      ResourceReference,
      { code: string; locale: Locale }
    >({
      query: ({ code, locale }) => `resource-ref/${code}/${locale}`,
      transformResponse: (response: { resourceRef: ResourceReference }) =>
        response.resourceRef,
    }),
    updateResource: build.mutation<
      { message: string },
      { diff: DeepPartial<Resource>; primaryKey: { PK: string; SK: string } }
    >({
      query(body) {
        return {
          url: "resource/save-resource",
          method: "POST",
          body,
          credentials: "include",
        };
      },
      invalidatesTags: ["Resource", "SubLesson", "Card", "ResourceStatus"],
    }),
    updateResourceReference: build.mutation<
      { message: string },
      {
        primaryKey: { PK: string; SK: string };
        refInformation: { locale: Locale; type: string; code: string };
        changes: DeepPartial<ResourceReference>;
      }
    >({
      query: (body) => {
        return {
          url: `resource-ref/save`,
          method: "POST",
          body: body,
          credentials: "include",
        };
      },
    }),
    getFullResource: build.query({
      query: ({ code }) => `resource/getFull/${code}`,
      transformResponse: (response: { fullResource: FullResource }) =>
        response.fullResource,
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetResourceQuery,
  useGetResourceReferenceQuery,
  useUpdateResourceMutation,
  useUpdateResourceReferenceMutation,
  useGetFullResourceQuery,
} = resourcesApi;
